export default {
    newDesign: true,
    parameters: {
        landing_id: "TrQShd",
        segment: 11,
        success_page: 'success_long'
    },
    title: "Çocuğunuz evden programlama öğrensin – eğlenceli ve kolay! | Kodland",
    downtimeUrl: "https://www.kodland.org/tr",
    startPage: {
        title:
            "İlk deneme dersinize kaydolmak için soruları cevaplayın.",
        subtitle:
            "Teknoloji tutkusunu bir avantaja dönüştürüyoruz:<br>💬 Çocuğunuzun yeteneklerini eğlenceli bir şekilde keşfedin<br>🌐 Sadece bir bilgisayar ve internet bağlantısına ihtiyacınız var<br>💙 Sadece bugün 270’den fazla çocuk kaydoldu",
        image: {
            url: "/welcome/tr_longquiz_dev_newpic_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/tr_longquiz_dev_newpic_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Haydi başlayalım! 🔥",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
    },
    quizRotateBySteps: {
        1: {
            title: "Çocuğunuz kaç yaşında?",
            type: "age",
            button: "",
        },
        2: {
            question: "Çocuğunuz boş zamanlarında en çok ne yapmayı sever?",
            answers: [
                "Spor yapmak veya açık havada oyunlar ⚽",
                "Kitap veya çizgi roman okumak 📚",
                "Televizyon izlemek, YouTube veya video oyunları 🎮",
                "Arkadaşlarıyla veya ailesiyle vakit geçirmek 👫",
                "Diğer 🙂"
            ]
        },

        3: {
            question: "Çocuğunuz programlama öğrenmeye ilgi gösterdi mi?",
            answers: [
                "Evet, öğrenmeye başladı bile 💻🚀",
                "Evet, merak ediyor ama denemedi 🤔💡",
                "Henüz değil, ama belki ilgilenir 🧑‍🎓",
                "Hayır, ilgilenmiyor 🙅"
            ],
        },
        4: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_before_after.png",
            subtitle: "Kodland’da öğrenciler 3D modeller tasarlar, çizgi romanlar oluşturur, oyunlar geliştirir ve programlama öğrenir. Şu anda dünya genelinde 30.000’den fazla çocuk bizimle öğreniyor!",
            button: "Harika ✅",
        },
        5: {
            question: "Çocuğunuz bulmacaları veya mantık problemlerini çözmekten hoşlanıyor mu?",
            answers: [
                "Evet, iyi bir meydan okumayı sever 🧠",
                "Bazen, konuyla ilgileniyorsa 👍",
                "Pek değil, daha yaratıcı görevleri tercih ediyor 🎨"
            ]
        },
        6: {
            question: "Çocuğunuzun eğitimi için ana hedefiniz nedir?",
            answers: [
                "Ekran süresini verimli kullanmak 💻",
                "Onu gelecekteki bir bilişim kariyerine hazırlamak 🚀",
                "Yaratıcılığını ve mantıksal düşünme becerisini geliştirmek 💡",
                "Yaratıcılığı ve mantığı geliştirmek 💡"
            ]
        },
        7: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_laptop.png",
            subtitle: "Bireysel ve grup öğrenme formatları sunuyoruz, süreci her çocuğun yaşına göre uyarlıyoruz, böylece mümkün olduğunca kişiselleştirilmiş oluyor.",
            button: "Haydi başlayalım!",
        },
        8: {
            question: "Çocuğunuzun ders çalışmak için bir dizüstü bilgisayara veya masaüstü bilgisayara erişimi var mı?",
            answers: [
                "Evet, kendi cihazı var 💻✅",
                {
                    answer: "Hayır, düzenli erişimi yok 🚫",
                    stopAnswer: true,
                }
            ],
        },
        9: {
            title: "🎉 Sadece bir adım kaldı!",
            typeInfo: "congrats",
            subtitle:
                "Çocuğunuza programlama ve dijital tasarım ile yaratıcı yönünü keşfetmesine yardımcı olun.<br>🌟 200.000’den fazla çocuk bizimle öğreniyor ve üretiyor.",
            button: "📅 Ücretsiz dersinizi ayırtın!",
        },
        10: {
            title: "🎉 Ücretsiz deneme dersine kaydolun",
            type: "one-page-contacts",
            subtitle: "Çocuğunuz ilk derste kendi mini oyununu oluşturacak — siz de katılabilirsiniz!",
            button: "✨ Harika! Sadece bir adım kaldı.",
        },
        11: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        12: {
            title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
            button: "Başka neler var?",
        },
        13: {
            title:
                "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        14: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        },
    },
};



